module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8555/img/website-performance-rating.jpg"